import { render, staticRenderFns } from "./MilestonesList.vue?vue&type=template&id=fa238292&scoped=true"
import script from "./MilestonesList.vue?vue&type=script&lang=js"
export * from "./MilestonesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa238292",
  null
  
)

export default component.exports